module.exports = __webpack_public_path__ + "img/nor_jy_moun1.4ec33a28.png";